/**
 * Zugriff auf die öffentliche API. Nur der Registrierungs-Endpunkt — kein
 * Token, keine Sitzung, siehe api/src/routes/registrierung.ts.
 */

export class ApiFehler extends Error {
  constructor(
    override readonly message: string,
    readonly status: number,
  ) {
    super(message);
  }
}

export interface RegistrierungsAntwort {
  ok: true;
  /** Nur außerhalb von Produktion gesetzt, wenn keine Mail versendet wurde. */
  link?: string;
}

export async function registrieren(daten: {
  name: string;
  email: string;
  telefon?: string;
  website?: string;
}): Promise<RegistrierungsAntwort> {
  const antwort = await fetch('/api/registrierung', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(daten),
  });

  if (!antwort.ok) {
    let text = 'Das hat leider nicht geklappt. Bitte später erneut versuchen.';
    try {
      const inhalt = (await antwort.json()) as { error?: string };
      if (inhalt.error) text = inhalt.error;
    } catch {
      /* keine JSON-Antwort – Standardtext bleibt */
    }
    throw new ApiFehler(text, antwort.status);
  }

  return (await antwort.json()) as RegistrierungsAntwort;
}
